export * from "./StandardProductDetails";
